import update from 'immutability-helper';
import {
  SET_SEARCH_PARAMS,
} from '../actions/ActionTypes';

const initialState = {
  byId: {},
  slideIndex: null,
  slideReferrer: null,
  currentSlideId: null,
};

export function slides(state = initialState, action) {
  switch (action.type) {
  case SET_SEARCH_PARAMS: {
    let {
      slideIndex,
      slideOrder,
      slideReferrer,
    } = action.payload;

    const hasSlideOrder = slideOrder && slideOrder.length;

    let currentSlideId = state.currentSlideId;

    // If slideIndex isn't being explicitly set then ensure its current value
    // is still correct; it needs updating when the deck's slides have changed
    // in some way, e.g. when slides are added, removed etc.
    if (slideIndex === undefined && hasSlideOrder && currentSlideId !== null) {
      slideIndex = slideOrder.findIndex(id => id === currentSlideId);
    }

    // When the order of the deck's slide IDs is passed in the payload, it's
    // an opportunity to set currentSlideId based on slideIndex. Again, if the
    // slideIndex changed due to, say, a slide being added, this will keep
    // currentSlideId in sync.
    if (hasSlideOrder) {
      currentSlideId = slideOrder[slideIndex >= 0 ? slideIndex : state.slideIndex];
    }

    return update(state, {
      currentSlideId: {$set: currentSlideId},
      slideIndex: {$set: slideIndex >= 0 ? slideIndex : state.slideIndex || 0},
      slideReferrer: {$set: slideReferrer}
    });
  }
  case 'SLIDE_RECEIVE': {
    const slide = action.payload;

    return update(state, {
      byId: {
        [slide.id]: {$set: slide}
      }
    });
  }
  default:
    return state;
  }
}
